export extraStopsReducer = (state = [], action) -> state
